import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, retry, shareReplay } from 'rxjs';
import { MyFamilyLiturgySchedule, LiturgySchedule } from 'src/models/liturgySchedule';
import { LiturgyType } from 'src/models/liturgyType';
import { AppSettings } from '../app-settings';
import { Schedule } from 'src/models/schedule';

@Injectable({
    providedIn: 'root',
})
export class ScheduleService {

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient, private appSettings: AppSettings) { }

    getMyFamilyLiturgySchedule(profileId: number, selectedLiturgyType: number): Observable<MyFamilyLiturgySchedule> {
        let url = this.appSettings.apiBaseUrl() + `Schedule/GetMyFamilySchedule?profileId=${profileId}&liturgyTypeId=${selectedLiturgyType}`;

        return this.http.get<MyFamilyLiturgySchedule>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    getLiturgySchedule(userId: number, selectedLiturgyType: number): Observable<LiturgySchedule[]> {
        let url = this.appSettings.apiBaseUrl() + `Schedule/GetLiturgySchedule?userId=${userId}&liturgyTypeId=${selectedLiturgyType}`;

        return this.http.get<LiturgySchedule[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    insertNewReservation(reservation: MyFamilyLiturgySchedule): Observable<number> {
        let url = this.appSettings.apiBaseUrl() + 'Schedule/InsertNewReservation';

        return this.http.post<number>(url, reservation, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    updateReservation(reservation: number): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + 'Schedule/UpdateNewReservation';

        return this.http.post<boolean>(url, reservation, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    cancelReservation(litFamilyAttId: number): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + 'Schedule/CancelReservation?liturgyFamilyAttId=' + litFamilyAttId;

        return this.http.get<boolean>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    getLiturgyTypes(): Observable<LiturgyType[]> {
        let url = this.appSettings.apiBaseUrl() + 'Schedule/GetLiturgyTypes'
        return this.http.get<LiturgyType[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    getSchedule(showDisabled: boolean = false): Observable<Schedule[]> {
        let url = this.appSettings.apiBaseUrl() + `Schedule/GetSchedule?showDisabled=${showDisabled}`
        return this.http.get<Schedule[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    insertSchedule(schedule: Schedule): Observable<Schedule> {
        let url = this.appSettings.apiBaseUrl() + `Schedule/InsertSchedule`
        return this.http.post<Schedule>(url, schedule, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }

    deleteSchedule(scheduleId): Observable<number> {
        let url = this.appSettings.apiBaseUrl() + `Schedule/DeleteSchedule?scheduleId=${scheduleId}`
        return this.http.get<number>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }
}